import { render, staticRenderFns } from "./SafeMarkdown.vue?vue&type=template&id=2ea28c04"
import script from "./SafeMarkdown.vue?vue&type=script&lang=js"
export * from "./SafeMarkdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports